import {combineEpics} from 'web-app/util/redux-observable';

import addInvoiceEpics from './add-invoice/epics';
import addInvoiceV2Epics from './add-invoice-v2/epics';
import billPayerEpics from './bill-payer-modal/epics';
import editBillPayersEpics from './edit-bill-payers/epics';
import linkContactEpics from './link-contact-modal/epics';
import depositEpics from './deposit-modal/epics';
import eventEpics from './event-modal/epics';
import invoiceEpics from './invoice/epics';
import accountItemMoveEpic from './account-item-move/epics';
import recipientsEpics from './recipients-modal/epics';
import obsReviewEpics from './review-observation-modal/epics';
import inquiryModalsEpics from './inquiry-modals/epics';
import newMessageEpics from './new-conversation-modal/epics';
import organizationPersonProfileEpics from './organization-person-profile-modal/epics';
import vacationPlanEpics from './vacation-plan-modal/epics';
import childPickup from './child-pickup-modal/epics';
import signIn from './signin-modal/epics';
import incidentReportModalEpics from './manage-report-modal/epics';
import mealSettingsModalEpics from './meal-settings-modal/epics';
import fileTaggingModalEpics from './file-tagging-modal/epics';
import observationEditorModalEpics from './observation-editor-modal/epics';

export default combineEpics(
    newMessageEpics,
    billPayerEpics,
    editBillPayersEpics,
    linkContactEpics,
    depositEpics,
    eventEpics,
    invoiceEpics,
    accountItemMoveEpic,
    recipientsEpics,
    obsReviewEpics,
    addInvoiceEpics,
    addInvoiceV2Epics,
    inquiryModalsEpics,
    organizationPersonProfileEpics,
    vacationPlanEpics,
    childPickup,
    signIn,
    incidentReportModalEpics,
    mealSettingsModalEpics,
    fileTaggingModalEpics,
    observationEditorModalEpics,
);
